import { Autocomplete, TextField } from "@mui/material";

export interface HeatFilterOption {
  HeatId: number;
  HeatName: string;
}

const ALL_OPTION: HeatFilterOption = { HeatId: 0, HeatName: "All" };

type Props = {
  options: HeatFilterOption[];
  value: number | null;
  onChange: (value: number | null) => void;
};

export const HeatFilter = ({ options, value, onChange }: Props) => {
  const items = [ALL_OPTION, ...options];
  const selected = items.find((h) => h.HeatId === (value ?? 0)) ?? ALL_OPTION;

  return (
    <Autocomplete
      options={items}
      getOptionLabel={(option) => option.HeatName}
      isOptionEqualToValue={(option, val) => option.HeatId === val.HeatId}
      value={selected}
      disableClearable
      onChange={(_event, newValue) => {
        const next = newValue ?? ALL_OPTION;
        onChange(next.HeatId === 0 ? null : next.HeatId);
      }}
      renderInput={(params) => (
        <TextField {...params} label="Heat" variant="outlined" fullWidth />
      )}
    />
  );
};
